import * as actions from "../actionTypes"

// show auto legend for diagrams - global setting
const initialState = {
    value: true,
}

export default function autoLegend(state = initialState, action) {
    switch (action.type) {
        case actions.SET_AUTO_LEGEND: {
            return {
                ...state,
                value: action.payload.value,
            }
        }

        default:
            return state
    }
}
